module.exports = __webpack_public_path__ + "National2Web-Extralight.woff?90d963c71fa52313f3630b57fd870a25";